import { render, staticRenderFns } from "./TopSellCountryWidget.vue?vue&type=template&id=0a3f3f88&scoped=true"
import script from "./TopSellCountryWidget.vue?vue&type=script&lang=js"
export * from "./TopSellCountryWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_react-dom@19.2.4_react@18.3.1_vue-templat_zb2mrinni5lndihrytzfraeym4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f3f88",
  null
  
)

export default component.exports